<template>
  <div v-if="data" class="relative h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('price-collection-document.documentNumber')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.documentHeader.documentNumber"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('price-collection-document.salesPerson')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.salesPerson.name"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('price-collection-document.traderSite')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.traderSite.name"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('price-collection-document.sendDate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.sendDate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('price-collection-document.isCompetitorPriceCollection')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.isCompetitorPriceCollection"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle
            v-else
            name="isCompetitorPriceCollection"
            v-model="data.isCompetitorPriceCollection" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isActive')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus v-if="mode == 'view'" :item="data.isActive" />
          <BaseToggle v-else name="isActiveDocument" v-model="data.isActive" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isFromManager')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            :item="data.isFromManager ? data.isFromManager : 0"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.lastUpdate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.lastUpdate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.updateUser')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ updateUser || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.createdDate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.createdDate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.createUser')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ createUser || '-' }}
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { isoDateToFullDate } from '@/utils/date';
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';
import BaseInput from '../common/BaseInput.vue';
import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseToggle from '../common/BaseToggle.vue';
import { onMounted, ref } from 'vue';
import type { PriceCollectionDocument } from '@/types/PriceCollectionDocuments';
import { useLookupsStore } from '@/stores/lookups';
import { storeToRefs } from 'pinia';

defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
}>();

const { users } = storeToRefs(useLookupsStore());

const createUser = ref<string>();
const updateUser = ref<string>();

const data = defineModel<PriceCollectionDocument>();

function loadData() {
  const createUserValue = users.value.find((user) => user.id == data.value?.createUserId);
  if (createUserValue) createUser.value = createUserValue.name;

  const updateUserValue = users.value.find((user) => user.id == data.value?.updateUserId);
  if (updateUserValue) updateUser.value = updateUserValue.name;
}

onMounted(async () => {
  loadData();
});
</script>
